import BasicResource from '@/api/resource';

class ExternalIntegrations extends BasicResource {
    constructor () {
        super('config/external-integrations');
    }

    toggle (id, action) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${id}/${action}`,
        });
    }
}

export default new ExternalIntegrations;
